import { XMarkIcon } from '@heroicons/react/24/outline';

import IconButton from '../../components/IconButton';
import Input from '../../components/Input';
import { t } from '../../i18n/langue';

interface RechercheConversationsProps {
    valeur: string;
    onChange: (valeur: string) => void;
    onEffacer: () => void;
}

/**
 * Le champ de recherche de la liste — #82.
 *
 * Par nom, prénom ou e-mail, DANS l'onglet courant : le serveur applique
 * `search` EN PLUS du filtre déjà posé par l'onglet (`unread`, `assigned_to_me`…),
 * jamais à sa place (`CustomerController`). Extrait de `ListeConversations`, déjà
 * à son plafond de lignes — le minuteur de 300 ms vit dans
 * `useRechercheConversations`.
 */
export default function RechercheConversations({ valeur, onChange, onEffacer }: RechercheConversationsProps) {
    return (
        <div className="mt-3 flex items-end gap-2">
            <div className="min-w-0 flex-1">
                <Input libelle={t('messagerie.recherche.libelle')} valeur={valeur} onChange={onChange} type="search" />
            </div>
            {valeur !== '' && (
                <IconButton libelle={t('messagerie.recherche.effacer')} onPress={onEffacer} className="mb-0.5">
                    <XMarkIcon className="h-5 w-5" aria-hidden="true" />
                </IconButton>
            )}
        </div>
    );
}
